// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { testAttributeChangeGroupId } from './TestAttributeChangeGroup';
import { testInstanceId } from './TestInstance';
import { testAttributeLineageId } from './TestAttributeLineage';
import { testTabularColumnLineageId } from './TestTabularColumnLineage';
import { testInstanceAttributeId } from './TestInstanceAttribute';
import { attributeChangeOp } from './AttributeChangeOp';
import { attributeChangeField } from './AttributeChangeField';
import { invItemId } from './InvItem';
import { fileStorageId } from './FileStorage';
import { testAttributeCodeCode } from './TestAttributeCode';
import { z } from 'zod';
export const testAttributeChangeEventId = (z.string());
export const testAttributeChangeEvent = z.object({
    id: testAttributeChangeEventId,
    group_id: testAttributeChangeGroupId,
    test_instance_id: testInstanceId,
    attribute_lineage_id: testAttributeLineageId.nullable(),
    column_lineage_id: testTabularColumnLineageId.nullable(),
    test_instance_attribute_id: testInstanceAttributeId.nullable(),
    tabular_row_id: z.string().nullable(),
    op: attributeChangeOp,
    field: attributeChangeField.nullable(),
    is_derived: z.boolean(),
    num_old: z.string().nullable(),
    num_new: z.string().nullable(),
    text_old: z.string().nullable(),
    text_new: z.string().nullable(),
    bool_old: z.boolean().nullable(),
    bool_new: z.boolean().nullable(),
    ts_old: z.date().nullable(),
    ts_new: z.date().nullable(),
    inv_item_id_old: invItemId.nullable(),
    inv_item_id_new: invItemId.nullable(),
    file_storage_id_old: fileStorageId.nullable(),
    file_storage_id_new: fileStorageId.nullable(),
    created_at: z.date(),
    attribute_code: testAttributeCodeCode.nullable(),
});
export const testAttributeChangeEventInitializer = z.object({
    id: testAttributeChangeEventId.optional(),
    group_id: testAttributeChangeGroupId,
    test_instance_id: testInstanceId,
    attribute_lineage_id: testAttributeLineageId.optional().nullable(),
    column_lineage_id: testTabularColumnLineageId.optional().nullable(),
    test_instance_attribute_id: testInstanceAttributeId.optional().nullable(),
    tabular_row_id: z.string().optional().nullable(),
    op: attributeChangeOp.optional(),
    field: attributeChangeField.optional().nullable(),
    is_derived: z.boolean().optional(),
    num_old: z.string().optional().nullable(),
    num_new: z.string().optional().nullable(),
    text_old: z.string().optional().nullable(),
    text_new: z.string().optional().nullable(),
    bool_old: z.boolean().optional().nullable(),
    bool_new: z.boolean().optional().nullable(),
    ts_old: z.date().optional().nullable(),
    ts_new: z.date().optional().nullable(),
    inv_item_id_old: invItemId.optional().nullable(),
    inv_item_id_new: invItemId.optional().nullable(),
    file_storage_id_old: fileStorageId.optional().nullable(),
    file_storage_id_new: fileStorageId.optional().nullable(),
    created_at: z.date().optional(),
    attribute_code: testAttributeCodeCode.optional().nullable(),
});
export const testAttributeChangeEventMutator = z.object({
    id: testAttributeChangeEventId.optional(),
    group_id: testAttributeChangeGroupId.optional(),
    test_instance_id: testInstanceId.optional(),
    attribute_lineage_id: testAttributeLineageId.optional().nullable(),
    column_lineage_id: testTabularColumnLineageId.optional().nullable(),
    test_instance_attribute_id: testInstanceAttributeId.optional().nullable(),
    tabular_row_id: z.string().optional().nullable(),
    op: attributeChangeOp.optional(),
    field: attributeChangeField.optional().nullable(),
    is_derived: z.boolean().optional(),
    num_old: z.string().optional().nullable(),
    num_new: z.string().optional().nullable(),
    text_old: z.string().optional().nullable(),
    text_new: z.string().optional().nullable(),
    bool_old: z.boolean().optional().nullable(),
    bool_new: z.boolean().optional().nullable(),
    ts_old: z.date().optional().nullable(),
    ts_new: z.date().optional().nullable(),
    inv_item_id_old: invItemId.optional().nullable(),
    inv_item_id_new: invItemId.optional().nullable(),
    file_storage_id_old: fileStorageId.optional().nullable(),
    file_storage_id_new: fileStorageId.optional().nullable(),
    created_at: z.date().optional(),
    attribute_code: testAttributeCodeCode.optional().nullable(),
});
//# sourceMappingURL=TestAttributeChangeEvent.js.map